<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
            b-container.d-flex.justify-content-between(fluid)
              div
                span.page-title {{$t('approval-process-history')}}
          b-container(fluid)
            b-row
              b-card.w-100(no-body)
                b-container(slot="header", fluid)
                  b-row.d-flex.align-items-center
                    b-col(cols="2")
                      datepicker(
                        :value="range.start",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        @selected="startDateChanged")
                    b-col(cols="2")
                      datepicker(
                        :value="range.end",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        :disabledDates="range.disabledDates",
                        @selected="endDateChanged")
                    b-col(cols="2")
                      b-form-select(v-model="filter.key" :options="filter.options", size="sm", @change="keyChangeHandler" style="text-align: center;")
                    b-col(cols="2")
                      b-form-input(v-model="filter.value" :placeholder="$t('name_requirement')", size="sm", @keydown.enter="tableRefresh")
                    b-col(cols="2")
                      b-button(size="sm", @click="tableRefresh") {{$t('search')}}

                b-table(
                  ref="approvalTable",
                  :fields="fields",
                  :items="approvalStatus",
                  :current-page="page.current",
                  :per-page="page.per",
                  :empty-text="$t('no-content')",
                  tbody-class="lmm-table-body",
                  sort-by="num",
                  :sort-desc="false",
                  show-empty)

                  template(v-slot:cell(device_alias)="row")
                    |{{row.item.device_alias}}
                  template(v-slot:cell(device_pub_ip)="row")
                    |{{row.item.device_pub_ip}}
                  template(v-slot:cell(proposal_time)="row")
                    |{{row.item.proposal_time| moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(start_time)="row")
                    |{{row.item.start_time| moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(end_time)="row")
                    |{{row.item.end_time| moment('YY-MM-DD HH:mm')}}
                  template(v-slot:cell(requester_name)="row")
                    |{{row.item.requester_name}} ({{row.item.requester_id}})
                  template(v-slot:cell(approve_state)="row")
                    b-btn(size='sm' variant="link" @click="approvalStatusCheck(row.item)")
                      template(v-if="row.item.approve_state === 1")
                        |{{$t('submit')}}
                      template(v-else-if="row.item.approve_state === 2")
                        |{{$t('approval')}}
                      template(v-else-if="row.item.approve_state === 4")
                        |{{$t('management_page.delete_device')}}

                div.d-flex.justify-content-between(slot="footer")
                  div
                    b-form-select(
                      size="sm",
                      v-model="page.per",
                      :options="page.perOptions")
                  b-pagination(
                    size="sm",
                    :total-rows="page.total",
                    :per-page="page.per",
                    v-model="page.current",
                    class="my-0 float-right"
                  )
</template>

<script>
import { ApprovalsAPI } from "../../../api"
import _ from "lodash"
import moment from "moment"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"

export default {
  name: "access-registration-view-component",
  components: { Datepicker },
  methods: {
    approvalStatusCheck(item) {
      let params = {
        context: { path: "reset_n", args: { v: "OTP" } },
        submit: {
          size: "md",
          color: "danger",
          text: "approval",
          sort: "admin_history",
        },
        item,
      }
      this.AppState.$emit("show-approval-request-dialog", params, (key, data) => {
        if (key === "reject") {
          let params = data
          ApprovalsAPI.post("", params).then(resp => {
            this.$refs.approvalTable.refresh()
            this.$awn.success(this.$t("approval-success"))
          })
        } else if (key === "submit") {
          let params = data
          ApprovalsAPI.post("", params).then(resp => {
            this.$refs.approvalTable.refresh()
            this.$awn.success(this.$t("approval-success"))
          })
        }
      })
    },
    async approvalStatus(ctx) {
      let params = {
        type: "history",
        by: "proposal_time",
        start_date: moment(this.range.start).format("YYYY-MM-DD HH:mm:ss"),
        end_date: moment(this.range.end).format("YYYY-MM-DD HH:mm:ss"),
        // start_date: this.range.start,
        // end_date: this.range.end,
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: "desc",
        export_id: "approvalsTable",
      }
      if (this.filter.value) {
        params.search_key = this.filter.key
        params.search_value = this.filter.value
      }
      const resp = await ApprovalsAPI.get("", { params })
      this.page.total = resp.data.meta.total_count

      return resp.data.objects
    },
    keyChangeHandler() {
      this.filter.value = ""
    },
    startDateChanged(date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged(date) {
      this.range.end = date
    },
    tableRefresh() {
      this.page.current = 1
      this.$refs.approvalTable.refresh()
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      range: {
        start: new Date().setDate(-1),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      fields: [
        // { key: 'pk', label: this.$t('access-num'), sortable: false },
        { key: "device_alias", label: this.$t("device-name"), sortable: false },
        { key: "device_pub_ip", label: this.$t("device-ip"), sortable: false },
        { key: "proposal_time", label: this.$t("application-date"), sortable: false },
        { key: "start_time", label: this.$t("start_time"), sortable: false },
        { key: "end_time", label: this.$t("end_time"), sortable: false },
        { key: "requester_name", label: this.$t("applicant"), sortable: false },
        { key: "approver_name", label: this.$t("approver"), sortable: false },
        { key: "approve_state", label: this.$t("approval-status"), sortable: false },
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
      filter: {
        key: "approver_name",
        value: "",
        options: [
          { text: this.$t("approver"), value: "approver_name" },
          { text: this.$t("applicant"), value: "requester_name" },
          { text: this.$t("device-name"), value: "device_alias" },
        ],
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row,
.col,
.container-fluid,
.container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.btn-link {
  color: black !important;
  font-weight: 400;
  border: 1px solid#6F6F6F;
}

.btn-link:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-link:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}
::v-deep .b-table {
  margin: 0;
  table-layout: fixed;
  width: 100%;
  tr,
  td,
  th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1),
  th:nth-child(2),
  th:nth-child(3),
  th:nth-child(4),
  th:nth-child(5),
  th:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
  }
  //th:nth-child(1)::after, th:nth-child(2)::after, th:nth-child(3)::after, th:nth-child(4)::after, th:nth-child(5)::after, th:nth-child(6)::after {
  //  content: "";
  //  position: absolute;
  //  right: 0;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  height: 60%;
  //  border-right: 0.1rem solid #6F6F6F;
  //}
  td:nth-child(1),
  td:nth-child(2),
  td:nth-child(3),
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6f6f6f;
  }
  //th:nth-child(8), td:nth-child(8) {
  //  text-align: center;
  //}
}

::v-deep .form-control,
.custom-select {
  display: flex;
  background-color: #ffffff !important;
  border: 1px solid #6f6f6f !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}

.btn-link {
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &:active {
    text-decoration: none;
  }
}
</style>
